import { Component } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../environments/environment';
import { AuthService } from '../../../app/shared/services/auth.service';

@Component({
    selector: 'app-register',
    templateUrl: './register.component.html',
    styleUrls: ['./register.component.scss']
})
export class RegisterComponent {
    public show: boolean = false;
    registerForm: FormGroup;
    isLoading = false;

    constructor(
        private fb: FormBuilder,
        private router: Router,
        private http: HttpClient,
        private toastr: ToastrService,
        private authService: AuthService
    ) {
        this.registerForm = this.fb.group({
            email: ['', [Validators.required, Validators.email]],
            name: ['', [Validators.required]],
            password: ['', [
                Validators.required,
                Validators.minLength(8),
                Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&./])[A-Za-z\d@$!%*?&./]+$/)
            ]],
            confirmPassword: ['', [Validators.required]],
        }, { validator: this.passwordMatchValidator });
    }

    passwordMatchValidator(form: FormGroup) {
        return form.get('password')?.value === form.get('confirmPassword')?.value
            ? null : { mismatch: true };
    }

    showPassword() {
        this.show = !this.show;
    }

    testPassword() {
        const password = 'Test.123';
        const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&.])[A-Za-z\d@$!%*?&.]+$/;
        console.log('Password test result:', pattern.test(password));
    }

    onSubmit() {
        if (this.registerForm.invalid) {
            this.markFormGroupTouched(this.registerForm);
            return;
        }

        this.isLoading = true;
        const payload = {
            email: this.registerForm.value.email,
            name: this.registerForm.value.name,
            password: this.registerForm.value.password
        };

        this.http.post(`${environment.apiUrl}auth/signup`, payload)
            .subscribe({
                next: (response: any) => {
                    this.isLoading = false;
                    this.toastr.success('Account created successfully!', 'Success');

                    this.authService.login(this.registerForm.value.email, this.registerForm.value.password)
                        .subscribe({
                            next: (loginResponse: any) => {
                                if (loginResponse.data?.access_token) {
                                    localStorage.setItem('accessToken', loginResponse.data.access_token);
                                    localStorage.setItem('user', JSON.stringify(loginResponse.data.user));
                                    this.router.navigate(['/warehouse']);
                                }
                            },
                            error: (loginError) => {
                                this.toastr.error('Account created but automatic login failed. Please login manually.', 'Error');
                                this.router.navigate(['auth/login']);
                            }
                        });
                },
                error: (error) => {
                    this.isLoading = false;
                    let errorMessage = 'Registration failed. Please try again.';

                    if (error.error?.message) {
                        if (Array.isArray(error.error.message)) {
                            errorMessage = error.error.message.join(', ');
                        } else {
                            errorMessage = error.error.message;
                        }
                    } else if (error.status === 409) {
                        errorMessage = 'Email or username already exists.';
                    } else if (error.status === 400) {
                        errorMessage = 'Invalid registration data. Please check your inputs.';
                    }

                    this.toastr.error(errorMessage, 'Error');
                }
            });
    }

    private markFormGroupTouched(formGroup: FormGroup) {
        Object.values(formGroup.controls).forEach(control => {
            control.markAsTouched();
            if (control instanceof FormGroup) {
                this.markFormGroupTouched(control);
            }
        });
    }
}